import { render, staticRenderFns } from "./VSettings.vue?vue&type=template&id=702f9cf6&"
import script from "./VSettings.vue?vue&type=script&lang=js&"
export * from "./VSettings.vue?vue&type=script&lang=js&"
import style0 from "./VSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports